export default __webpack_public_path__ + "static/1849-8584f41da4cf7e4dc6379471d614d55b.gif";